import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AiChatService {
    private readonly document = inject(DOCUMENT);
    private isInitted = false;

    initChatBot(): void {
        if (this.isInitted) {
            return;
        }
        this.isInitted = true;

        const script = this.document.createElement('script');
        script.id = 'ai-chat-script';
        script.src = 'https://ai-chat.obecni.net/widget/90167eea-fdbd-4400-9cef-050fabb3a5f9/default.js';
        this.document.head.appendChild(script);
    }

    destroyChatBot(): void {
        if (!this.isInitted) {
            return;
        }
        this.isInitted = false;

        const script = this.document.getElementById('ai-chat-script');
        if (script) {
            script.remove();
        }
    }
}
